import type { PartialOptions } from 'overlayscrollbars';

export const SCROLL_AREA_THEME = 'os-theme-theysaid';

export const SCROLL_AREA_DEFER: IdleRequestOptions = { timeout: 300 };

export const scrollAreaDefaultOptions: PartialOptions = {
  scrollbars: {
    theme: SCROLL_AREA_THEME,
    autoHide: 'leave',
    autoHideDelay: 0,
    autoHideSuspend: false,
  },
};

let lastMergedInput: PartialOptions | null = null;
let lastMergedResult: PartialOptions = scrollAreaDefaultOptions;

export function mergeScrollAreaOptions(
  options?: PartialOptions | false | null
): PartialOptions {
  if (!options || typeof options !== 'object') {
    return scrollAreaDefaultOptions;
  }

  if (options === lastMergedInput) return lastMergedResult;

  const merged = {
    ...scrollAreaDefaultOptions,
    ...options,
    scrollbars: {
      ...scrollAreaDefaultOptions.scrollbars,
      ...options.scrollbars,
    },
  };

  lastMergedInput = options;
  lastMergedResult = merged;

  return merged;
}
